<template>
  <BaseButton
    :variant="computedVariant"
    :size="size"
    :disabled="disabled"
    :active="active"
    :icon-left="getIcon()"
    @click="$emit('click', $event)"
  >
    <slot>{{ getDefaultLabel() }}</slot>
  </BaseButton>
</template>

<script>
import BaseButton from "./BaseButton.vue";
import {
  PlusIcon,
  PencilIcon,
  TrashIcon,
  EyeIcon,
  ArrowLeftIcon,
  FunnelIcon,
  CheckIcon,
  XMarkIcon,
} from "@heroicons/vue/24/outline";

export default {
  name: "ActionButton",
  components: { BaseButton },
  props: {
    action: {
      type: String,
      required: true,
      validator: (value) =>
        [
          "add",
          "edit",
          "delete",
          "view",
          "back",
          "filter",
          "save",
          "cancel",
          "create",
        ].includes(value),
    },
    variant: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: "md",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["click"],
  methods: {
    getIcon() {
      const icons = {
        add: PlusIcon,
        edit: PencilIcon,
        delete: TrashIcon,
        view: EyeIcon,
        back: ArrowLeftIcon,
        filter: FunnelIcon,
        save: CheckIcon,
        cancel: XMarkIcon,
        create: PlusIcon,
      };
      return icons[this.action];
    },
    getDefaultLabel() {
      const labels = {
        add: "Add",
        edit: "Edit",
        delete: "Delete",
        view: "View",
        back: "Back",
        filter: "Filter",
        save: "Save",
        cancel: "Cancel",
        create: "Create",
      };
      return labels[this.action];
    },
  },
  computed: {
    computedVariant() {
      if (this.variant) return this.variant;

      const defaultVariants = {
        add: "primary",
        edit: "secondary",
        delete: "outline",
        view: "ghost",
        back: "ghost",
        filter: "filter",
        save: "primary",
        cancel: "outline",
        create: "gradient",
      };
      return defaultVariants[this.action];
    },
  },
};
</script>
